var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.725 12.0001L7.375 19.3501C7.125 19.6001 7.00417 19.8918 7.0125 20.2251C7.02083 20.5584 7.15 20.8501 7.4 21.1001C7.65 21.3501 7.94167 21.4751 8.275 21.4751C8.60833 21.4751 8.9 21.3501 9.15 21.1001L16.85 13.4251C17.05 13.2251 17.2 13.0001 17.3 12.7501C17.4 12.5001 17.45 12.2501 17.45 12.0001C17.45 11.7501 17.4 11.5001 17.3 11.2501C17.2 11.0001 17.05 10.7751 16.85 10.5751L9.15 2.87511C8.9 2.62511 8.60417 2.50428 8.2625 2.51261C7.92083 2.52094 7.625 2.65011 7.375 2.90011C7.125 3.15011 7 3.44178 7 3.77511C7 4.10844 7.125 4.40011 7.375 4.65011L14.725 12.0001Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.0c3e70406b9a0a44833f8336c99cb21d.svg";
export { ForwardRef as ReactComponent };